<template>
  <div class="container">
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <b-col v-if="!fetchData">
      <table class="table table-striped table-bordered">
        <thead style="position: sticky; top: 0; background-color: gray;">
          <tr>
            <th rowspan="2">No.</th>
            <th rowspan="2">Student</th>
            <th>Total Score</th>
          </tr>
          <tr>
            <b-form-input style="border: 1px solid #52595f;" v-model="classParticipantsMaxScore" required type="number"
              placeholder="Max Score"></b-form-input>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, studindex) in students" :key="studindex">
            <th class="fixed-table-column">{{ student.roll_number }}</th>
            <th class="fixed-table-column">
              {{ student.first_name }} {{ student.last_name }}
            </th>
            <td style="min-width: 60px;">
              <b-form-input v-model="evaluationTableData[student.institution_user_id]" :max="classParticipantsMaxScore"
                type="number" placeholder="Enter score"></b-form-input>
            </td>
          </tr>
        </tbody>
      </table>

      <b-button @click="updateClassParticipantsEvaluation()"
        :disabled="updateClassParticipantsEvaluationButton !== 'Save'" variant="primary">
        {{ updateClassParticipantsEvaluationButton }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["course_id"],
  async created() {
    await this.fetchCourseStudents();
    this.students.forEach(stud => {
      this.$set(this.evaluationTableData, stud.institution_user_id, null);
    });
    this.fetchData = false;
    await this.getClassParticipantsEvaluations();
  },
  data() {
    return {
      fetchData: false,
      updateClassParticipantsEvaluationButton: "Save",
      students: [],
      classParticipantsMaxScore: null,
      evaluationTableData: {},
    };
  },
  methods: {
    async getClassParticipantsEvaluations() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/classparticipants?course=${this.course_id}`;
      try {
        const response = await axios.get(url);
        this.classParticipantsMaxScore = response.data.max_score;

        response.data.seminar_evaluations.forEach(evaluation => {
          if (Object.prototype.hasOwnProperty.call(this.evaluationTableData, evaluation.student_id)) {
            this.$set(this.evaluationTableData, evaluation.student_id, parseFloat(evaluation.score));
          }
        });
      } catch (error) {
        console.error("Error fetching class participation evaluations:", error);
      }
    },
    async updateClassParticipantsEvaluation() {
      this.updateClassParticipantsEvaluationButton = "Saving...";
      const postData = [];

      for (const [studkey, score] of Object.entries(this.evaluationTableData)) {
        if (score !== null) {
          postData.push({
            score: score,
            student_id: studkey
          });
        }
      }

      const url = `${this.$store.getters.getAPIKey.mainAPI}/classparticipants`;
      try {
        await axios.post(url, {
          classParticipantsEvaluations: postData,
          course: this.course_id,
          max_score: this.classParticipantsMaxScore
        });

        this.$toast.success("Updated successfully", {
          position: "top",
          duration: 3000,
        });
      } catch (error) {
        this.$toast.error("Failed to update", {
          position: "top",
          duration: 3000,
        });
        this.fetchData = false;
      }

      this.updateClassParticipantsEvaluationButton = "Save";
    },
    async fetchCourseStudents() {
      const mainUrl = this.$store.getters.getAPIKey.createStudent;
      const url = mainUrl.replace("course_id", this.course_id);

      try {
        const response = await this.$axios.get(url);
        this.students = response.data[0] || [];
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    },
  },
};
</script>

<style>
.tag-button button {
  font-size: 9px !important;
  padding: 3px;
}

.labEvaluation .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed;
  z-index: 100000;
}

.labEvaluation .modal-body {
  overflow: scroll;
}

.labEvaluation .fixed-table-column {
  position: sticky;
  left: 0;
  background-color: gray;
}
</style>
